import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import styled from 'styled-components';
import { Box } from "../../box/src";
import { useBreakpoint } from "../../theme/src";
import { Description } from './Description';
import { Drop } from './Drop';
export const UploadMultiple = (props) => (_jsx(DndProvider, { backend: HTML5Backend, children: _jsx(UploadMultipleDrop, Object.assign({}, props)) }));
const UploadMultipleDrop = ({ acceptedFiles, children, dataTestId, description, height = '300px', name, onAddFiles, title, width = '100%', }) => {
    const inputFileRef = useRef(null);
    const breakpoint = useBreakpoint();
    const hasChildren = Boolean(children);
    const isMobileAndNotEmpty = breakpoint === 's' && hasChildren;
    const handleClick = () => {
        if (inputFileRef.current) {
            inputFileRef.current.value = '';
            inputFileRef.current.click();
        }
    };
    const readFiles = (filesToRead) => {
        if (!filesToRead) {
            return;
        }
        let acceptedItems = Array.from(filesToRead);
        if (acceptedFiles) {
            acceptedItems = acceptedItems.filter((file) => acceptedFiles.includes(file.type));
        }
        if (acceptedItems.length) {
            onAddFiles === null || onAddFiles === void 0 ? void 0 : onAddFiles(acceptedItems);
        }
    };
    const handleChangeInputFile = (event) => {
        const { files: filesToRead } = event.target;
        filesToRead && readFiles(filesToRead);
    };
    const handleOnDrop = (droppedFiles) => {
        readFiles(droppedFiles.files);
    };
    return (_jsx(Drop, { onDrop: handleOnDrop, children: ({ isHover }) => (_jsxs(Wrapper, { "$isHover": isHover, "$isMobileAndNotEmpty": isMobileAndNotEmpty, "data-testid": dataTestId, height: height, width: width, children: [hasChildren && _jsx(Content, { children: children }), _jsx(Description, { description: description, hasChildren: hasChildren, isHover: isHover, isMobileAndNotEmpty: isMobileAndNotEmpty, onUpload: handleClick, title: title }), _jsx(InputHidden, { accept: acceptedFiles ? acceptedFiles.join(',') : undefined, "aria-hidden": true, hidden: true, multiple: true, name: name, onChange: handleChangeInputFile, ref: inputFileRef, tabIndex: -1, type: "file" })] })) }));
};
const Wrapper = styled(Box).attrs(({ height }) => ({
    alignItems: 'center',
    flexDirection: 'column',
    height: 'auto',
    minHeight: height,
})) `
  border-radius: ${({ theme }) => `${theme.themeVariables.globalBorderRadius}px`};
  border: ${({ $isHover, $isMobileAndNotEmpty, theme }) => $isHover || $isMobileAndNotEmpty
    ? 0
    : `1px dashed ${theme.colors.primary}`};
  position: relative;
  background-color: ${({ $isHover, $isMobileAndNotEmpty, theme }) => $isHover
    ? theme.colors.primary
    : $isMobileAndNotEmpty
        ? 'transparent'
        : theme.input.bg};
`;
const Content = styled(Box).attrs({
    pt: { _: 0, m: 6 },
    px: { _: 0, m: 6 },
    width: '100%',
}) ``;
const InputHidden = styled.input `
  position: absolute;
  height: 0;
  opacity: 0;
  width: 0;
`;
//# sourceMappingURL=UploadMultiple.js.map